import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'password-strength-checker',
    templateUrl: './password-strength-checker.html',
    styleUrls: ['./password-strength-checker.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordStrengthCheckerComponent {
    @Input()
    password?: string;

    /**
     * Returns a value from 0 to 100
     */

    get passwordScore(): number {
        if (!this.password) {
            return 0;
        }

        let passwordScore = 0;

        let rulesApplied = 0;

        if (this.password.length >= 8) {
            passwordScore += 10;
            rulesApplied++;
        }

        /**
         * Check if password contains at least 1 number
         */
        if (/\d/.test(this.password)) {
            passwordScore += 5;
            rulesApplied++;
        }

        /**
         * Check if password contains at least 1 uppercase letter
         */
        if (/[A-Z]/.test(this.password)) {
            passwordScore += 5;
            rulesApplied++;
        }

        /**
         * Check if password contains at least 1 lowercase letter
         */
        if (/[a-z]/.test(this.password)) {
            passwordScore += 5;
            rulesApplied++;
        }

        /**
         * Check if password contains at least 1 special character
         */
        if (/[!@#$%^&*]/.test(this.password)) {
            passwordScore += 10;
            rulesApplied++;
        }

        /**
         * Check if password contains at least 5 unique characters
         */
        if (this.findUnique(this.password).length >= 5) {
            passwordScore += 5;
            rulesApplied++;
        }

        return passwordScore + rulesApplied * 10;
    }

    private findUnique(text: string) {
        return [...text].reduce((acc, curr) => {
            return acc.includes(curr) ? acc : acc + curr;
        }, '');
    }

    get passwordStrength(): string {
        const passwordScore = this.passwordScore;

        if (passwordScore < 50 && passwordScore !== 0) {
            return 'Weak';
        }

        if (passwordScore >= 50 && passwordScore < 75) {
            return 'Average';
        }

        if (passwordScore >= 75 && passwordScore < 95) {
            return 'Strong';
        }

        if (passwordScore >= 95) {
            return 'Very Strong';
        }

        return '';
    }

    get barColor(): string {
        const passwordScore = this.passwordScore;

        if (passwordScore < 50) {
            return 'bg-col-2';
        }

        if (passwordScore >= 50 && passwordScore < 75) {
            return '_yellow';
        }
        return 'bg-col-3';
    }
}
